import { AdminOrganizationEmployeeNode, Loading, SearchBox, Table } from "@cpj-ai/panel-npm-package";
import { useGetOrganizationEmployeesQuery } from "@graphql/generated";
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { IFormData, inputConfigs } from "./../../searchBoxFormConfig";
import { getEmployeesColumns } from "./columns";

const EmployeesTable: React.FC = () => {
  const { id } = useParams();

  const columns = useMemo(() => getEmployeesColumns(), []);

  const { data, loading, refetch } = useGetOrganizationEmployeesQuery({
    variables: {
      organizationId: id as string,
    },
  });

  const filterData = (formData: IFormData) => {
    refetch({
      ...formData,
      locationType: formData.locationType?.value,
      status: formData.status?.value,
    });
  };

  const employees = (data?.admin?.organizations?.edges[0]?.node?.organizationEmployees?.edges
    ?.map((employee) => employee?.node)
    .filter((node): node is NonNullable<typeof node> => node !== null && node !== undefined) ??
    []) as AdminOrganizationEmployeeNode[];

  if (loading) return <Loading />;

  return (
    <div className="flex flex-col gap-4 ">
      <SearchBox inputConfigs={inputConfigs} filterItems={filterData} />
      <Table<AdminOrganizationEmployeeNode>
        columns={columns}
        data={employees}
        aria-label="Company information table"
        bottomContentCustomComponent={<></>}
      />
    </div>
  );
};

export default EmployeesTable;
